import Stepper from "../../../../components/Businesses/Stepper/Index"

const CreateBusiness = () => {
    return (
        <Stepper />
    )
}
export default CreateBusiness